export default {
  // CONFIG DATA
  fmod: '',
  ftail1: '',
  ftail2: '',
  fopt: '',
  fcol: '',
  fmarq: '',
  fgrpcol: '',
  fqte: '',
  total_price: 0,
  stock_availibility: '',
  display_button_add_to_cart: true,
  price_unit: '',
  // DISPLAY DATA  
  descm_long: '',
  descm_court: '',
  desc_prod: '',
  compo: '',
  
  division_img: [],
  collection_card: {},
  
  // EVENT DATA
  launch_config: false,
  launch_stock: false,
  launch_price: false,
  // DATA
  product_config_width: [],
  product_config_packaging: [],
  product_config_color: [],
  product_config_color_reference: []
};